import { MY_PLAYLISTS_TABS } from '../myPlaylistsTypes';
import { getMyPlaylistsUrl } from '../myPlaylistsRouting';
import { useMyPlaylistsParams } from '../myPlaylistsHooks';
import I18n from 'I18n';
import useNavigate from '../../../hooks/useNavigate';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const MyPlaylistsTabNavigation = ({
  Wrapper
}) => {
  const navigate = useNavigate();
  const {
    tab: selectedTab
  } = useMyPlaylistsParams();
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "500",
    children: /*#__PURE__*/_jsx(Tabs, {
      Wrapper: Wrapper,
      selected: selectedTab,
      children: MY_PLAYLISTS_TABS.map(tab => /*#__PURE__*/_jsx(Tab, {
        onClick: () => navigate(getMyPlaylistsUrl({
          tab
        })),
        tabId: tab,
        title: I18n.text(`learningCenter.topFilters.myPlaylistsType.${tab}`)
      }, tab))
    })
  });
};